export default __webpack_public_path__ + "media/src/usersite/images/footer/note_logo-01c4b227155a9838c08aa5b8f44e8983.svg";